import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function Header() {
  return (
    <header className="site-header sticky-top" dir="rtl">
      <a
        href="#main-content"
        className="visually-hidden-focusable position-absolute top-0 start-0 m-2 btn btn-primary btn-sm z-3"
      >
        تخطي إلى المحتوى الرئيسي
      </a>

      <nav
        className="navbar navbar-expand-lg navbar-light py-3"
        aria-label="القائمة الرئيسية"
      >
        <div className="container">
          <Link
            to="/"
            className="navbar-brand d-flex align-items-center me-0"
            aria-label="سداد قروض صبيا وأبو عريش وجازان — الصفحة الرئيسية"
          >
            <span className="fw-bold fs-4 text-primary">
              سداد قروض <span className="text-dark">صبيا</span>
              <span className="text-muted fs-6 fw-semibold ms-1">
                | أبو عريش وجازان
              </span>
            </span>
          </Link>

          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="فتح قائمة التنقل"
          >
            <span className="navbar-toggler-icon" aria-hidden="true"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-1 pt-3 pt-lg-0">
              <li className="nav-item">
                <Link
                  className="nav-link fw-bold text-primary active-link px-3"
                  to="/"
                  aria-current="page"
                >
                  الرئيسية
                </Link>
              </li>
              <li className="nav-item">
                <HashLink
                  smooth
                  className="nav-link fw-bold text-secondary px-3"
                  to="/#services"
                >
                  خدماتنا
                </HashLink>
              </li>
              <li className="nav-item">
                <HashLink
                  smooth
                  className="nav-link fw-bold text-secondary px-3"
                  to="/#features"
                >
                  لماذا نحن؟
                </HashLink>
              </li>
              <li className="nav-item">
                <HashLink
                  smooth
                  className="nav-link fw-bold text-secondary px-3"
                  to="/#areas"
                >
                  مناطق الخدمة
                </HashLink>
              </li>
              <li className="nav-item">
                <HashLink
                  smooth
                  className="nav-link fw-bold text-secondary px-3"
                  to="/#steps"
                >
                  آلية العمل
                </HashLink>
              </li>
              <li className="nav-item">
                <HashLink
                  smooth
                  className="nav-link fw-bold text-secondary px-3"
                  to="/#faq"
                >
                  الأسئلة الشائعة
                </HashLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
